module.exports = __webpack_public_path__ + "static/img/float-help.2cc5a53.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/float-help.png
// module id = /Lo2
// module chunks = 3